/**
 * Shared sticky-position offsets for the main layout's stacking layers.
 *
 * Layer order (top → down):
 *   1. App header              xs: 66px   md: 88px
 *   2. Breadcrumb bar          xs: 64px   md: 70px  (sits beneath the header)
 *   3. TabView tab bar         = header + breadcrumb bar
 *
 * Update these constants whenever the header or breadcrumb bar height changes
 * so every sticky consumer stays in sync automatically.
 */

/** Top of the sticky breadcrumb bar (= app header height). */
export const BREADCRUMB_STICKY_TOP = { xs: 66, md: 88 };

/** Top of the sticky tab bar (= header height + breadcrumb bar height). */
export const TAB_STICKY_TOP = { xs: 130, md: 158 };
